import { render, staticRenderFns } from "./edit.blog-tag.page.vue?vue&type=template&id=14836355&"
import script from "./edit.blog-tag.page.vue?vue&type=script&lang=js&"
export * from "./edit.blog-tag.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports